import * as MaplibreGL from 'maplibre-gl';
import GA from 'react-ga4';
import config from './../config';
/**
 * @example
 * nextbillion.setApiKey("your_api_key")
 * var map = new nextbillion.maps.Map({
 *   container: 'map',
 *   center: [-122.420679, 37.772537],
 *   zoom: 13,
 *   style: 'https://api.nextbillion.io/maps/streets/style.json',
 *   hash: true,
 * });
 *
 */
export class NBMap {
    constructor(options) {
        if (!config.API_KEY) {
            const msg = 'An API Key is required to create a map!';
            alert(msg);
            throw new Error(msg +
                ' For example, add this line of code before creating a new map instance: nextbillion.setApiKey("your_api_key")');
        }
        GA.event({
            category: 'web_sdk_2',
            action: 'map_instance_created',
            label: '2.0',
        });
        this._options = Object.assign({}, options);
        const mapboxOptions = Object.assign({
            transformRequest,
        }, options);
        this._map = new MaplibreGL.Map(mapboxOptions);
        const attrib = new MaplibreGL.AttributionControl({
            customAttribution: '<a href="https://nextbillion.ai" target="_blank">&copy; NextBillion.ai</a> <a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
        });
        this._map._controls[0] && this._map.removeControl(this._map._controls[0]);
        this._map.addControl(attrib);
    }
    get map() {
        return this._map;
    }
    setStyle(style, options) {
        this._map.setStyle(style, options);
        return this;
    }
    on(type, listener) {
        this._map.on(type, listener);
        return this;
    }
}
function transformRequest(url, resourceType) {
    const key = config.API_KEY;
    if (config.DISABLE_NB_TRANSFORM) {
        return { url };
    }
    if ((resourceType === 'SpriteJSON' ||
        resourceType === 'SpriteImage' ||
        resourceType === 'Tile' ||
        resourceType === 'Source' ||
        resourceType === 'Style') &&
        key) {
        return {
            url: urlAddOrReplaceParam(url, { key: key }),
        };
    }
    return { url };
}
function urlAddOrReplaceParam(baseUrl, params) {
    const url = new URL(baseUrl);
    for (const key in params) {
        url.searchParams.set(key, params[key]);
    }
    return url.toString();
}
//# sourceMappingURL=map.js.map